
import { Link } from 'react-router-dom';
import Logo from '../../../components/base/Logo';

export default function Header() {
  return (
    <header className="bg-white shadow-sm border-b border-gray-100">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo - Left Side */}
          <Link to="/" className="flex items-center cursor-pointer">
            <h1>
              <Logo size="large" />
            </h1>
          </Link>

          {/* Navigation - Right Side */}
          <div className="flex items-center space-x-8">
            <nav className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 cursor-pointer">Home</Link>
              <Link to="/fleet" className="text-blue-600 font-semibold cursor-pointer">Fleet</Link>
              <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 cursor-pointer">Locations</a>
              <a href="#" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 cursor-pointer">Corporate</a>
              <Link to="/contact" className="text-gray-600 hover:text-blue-600 transition-colors duration-200 cursor-pointer">Contact</Link>
            </nav>

            <button className="hidden md:block bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg font-semibold transition-colors duration-200 whitespace-nowrap cursor-pointer">
              Reserve Now
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
